export { default } from './ContentfulRichText'
